<template>
    <div class="registration-page">
        <section id="home">
            <div class="container">
                <div>
                    <div class="row">
                        <div class="col-md-12 mobile-view-header">
                            <h2>Registration</h2>
                            <p v-html="conferenceTextData.registration_text"></p>
                            <p>
                                Should you have any questions, please email
                                <a class="text_underline" :href="'mailto:' +
                                    conferenceTextData.conference_email
                                    ">{{ conferenceTextData.conference_email }}
                                </a>
                            </p>
                        </div>
                    </div>
                    <center>
                        <div class="col-md-4">
                            <div class="session_box alert alert-warning text-center center-block">
                                <span class="fa fa-warning fa-fw"></span>
                                Your Session will expire in
                                <strong>
                                    <span id="timer">{{ remaining_timer }}</span>!</strong>
                            </div>
                        </div>
                    </center>
                </div>
            </div>
        </section>

        <div>
            <section>
                <div class="container">
                    <div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-danger error-summary" v-if="errors.length > 0 ||
                                    $v.registration_form.$invalid == true
                                    ">
                                    <ul>
                                        <li class="text-danger" v-if="form_options.enableLoginDetails
                                            ? !$v.registration_form
                                                .login_details
                                                .username.required
                                            : false
                                            ">
                                            Username field is required
                                        </li>
                                        <li v-if="form_options.enableLoginDetails
                                            ? !$v.registration_form
                                                .login_details
                                                .username.minLength
                                            : false
                                            " class="text-danger">
                                            Username must have at least 6
                                            letters.
                                        </li>
                                        <li v-if="errors['username']" class="text-danger">
                                            {{ errors["username"] }}
                                        </li>
                                        <li v-if="form_options.enableLoginDetails
                                            ? !$v.registration_form
                                                .login_details
                                                .password.required
                                            : false
                                            " class="text-danger">
                                            Password field is required
                                        </li>
                                        <li v-if="form_options.enableLoginDetails
                                            ? !$v.registration_form
                                                .login_details
                                                .password.minLength
                                            : false
                                            " class="text-danger">
                                            Password must have at least 6
                                            letters.
                                        </li>
                                        <li class="text-danger" v-if="form_options.enableLoginDetails ==
                                            true
                                            ? !$v.registration_form
                                                .login_details
                                                .password_confirmation
                                                .sameAs
                                            : false
                                            ">
                                            Passwords must be identical.
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details.job_title
                                            .required
                                            ">
                                            Job title field is required
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details.address
                                            .required
                                            ">
                                            Address field is required
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details.country_id
                                            .required
                                            ">
                                            Country field is required
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details
                                            .nationality_id.required
                                            ">
                                            Nationality Field is required
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details
                                            .additional_email.email
                                            ">
                                            Additional email is invalid email
                                            address
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details.telephone
                                            .required
                                            ">
                                            Telephone field is required
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details.mobile
                                            .required
                                            ">
                                            mobile field is required
                                        </li>
                                        <li class="text-danger" v-if="!$v.registration_form
                                            .client_details
                                            .assistant_email.email
                                            ">
                                            Assistant email is invalid email
                                            address
                                        </li>
                                        <li class="text-danger" v-if="form_options.allow_investor_slots_registration &&
                                            form_options.isInvestor &&
                                            !$v.registration_form
                                                .available_slot.required
                                            ">
                                            Available slot field is required
                                        </li>
                                        <!-- <li class="text-danger" v-if="form_options.isPresenter && !$v.registration_form.available_slot.required">Available slot field is required</li> -->
                                        <!-- <li class="text-danger" v-if="form_options.isPresenter && !$v.registration_form.presenter_slots.required"> Slots in day required </li> -->
                                        <li class="text-danger" v-if="form_options.isInvestor &&
                                            !$v.registration_form
                                                .client_details.biography
                                                .required
                                            ">
                                            Biography field is required
                                        </li>
                                        <li class="text-danger" v-if="!form_options.disable_arrival_dates
                                            ? !$v.registration_form
                                                .arrival_dates
                                                .arrival_date.minValue
                                            : false
                                            ">
                                            Arrival date shouldn't be after the
                                            first attending day.
                                        </li>
                                        <li class="text-danger" v-if="!form_options.disable_arrival_dates
                                            ? !$v.registration_form
                                                .arrival_dates
                                                .arrival_date.required
                                            : false
                                            ">
                                            Arrival Dates field is required
                                        </li>
                                        <li class="text-danger" v-if="!form_options.disable_arrival_dates
                                            ? !$v.registration_form
                                                .arrival_dates
                                                .arrival_time.required
                                            : false
                                            ">
                                            Arrival time Field is required
                                        </li>
                                        <li class="text-danger" v-if="!form_options.disable_depature_dates
                                            ? !$v.registration_form
                                                .arrival_dates
                                                .departure_date
                                                .required
                                            : false
                                            ">
                                            departure date field is required
                                        </li>
                                        <li class="text-danger" v-if="!form_options.disable_depature_dates
                                            ? !$v.registration_form
                                                .arrival_dates
                                                .departure_date
                                                .minValue
                                            : false
                                            ">
                                            Depature date shouldn't be after the
                                            last attending day.
                                        </li>
                                        <li class="text-danger" v-if="!form_options.disable_depature_dates
                                            ? !$v.registration_form
                                                .arrival_dates
                                                .departure_time
                                                .required
                                            : false
                                            ">
                                            Departure Time Field is required
                                        </li>
                                        <li class="text-danger" v-if="form_options.isPresenter &&
                                            registration_form.screen == null
                                            ">
                                            Audio Visual (A/V) field is required
                                        </li>
                                        <li class="text-danger" v-if="form_options.isPresenter &&
                                            registration_form.media_interview ==
                                            null
                                            ">
                                            Media Interview field is required
                                        </li>
                                    </ul>
                                </div>
                                <fieldset class="fieldset-padding">
                                    <legend>Login Details</legend>
                                    <p class="font-bold font-87">
                                        Please create a Username and Password
                                        that you can use to access your personal
                                        registration information in the future,
                                        and then click the &quot;Submit&quot;
                                        button.
                                    </p>

                                    <div class="row">
                                        <div class="col-lg-4 col-sm-12" :class="{
                                            'has-error':
                                                form_options.enableLoginDetails
                                                    ? $v.registration_form
                                                        .login_details
                                                        .username
                                                        .$invalid ||
                                                    errors['username']
                                                    : false,
                                        }">
                                            <label class="font-bold font-8">
                                                Username
                                                <span class="required">*</span></label>
                                            <input :disabled="!form_options.enableLoginDetails
                                                " v-model="registration_form
        .login_details.username
        " type="text" />
                                            <small class="text-danger" v-if="form_options.enableLoginDetails
                                                ? !$v.registration_form
                                                    .login_details
                                                    .username.required
                                                : false
                                                ">Field is required</small>
                                            <small v-if="form_options.enableLoginDetails
                                                ? !$v.registration_form
                                                    .login_details
                                                    .username
                                                    .minLength
                                                : false
                                                " class="text-danger">Username must have at least 6
                                                letters.</small>
                                            <small v-if="errors['username']" class="text-danger">{{ errors["username"]
                                            }}</small>
                                        </div>

                                        <div class="col-lg-4 col-sm-12" :class="{
                                                'has-error':
                                                    form_options.enableLoginDetails
                                                        ? $v.registration_form
                                                            .login_details
                                                            .password.$invalid
                                                        : false,
                                            }">
                                            <label class="font-bold font-8">
                                                Password
                                                <span class="required">*</span></label>
                                            <input :disabled="!form_options.enableLoginDetails
                                                " v-model="registration_form
        .login_details.password
        " type="password" />
                                            <small v-if="form_options.enableLoginDetails
                                                ? !$v.registration_form
                                                    .login_details
                                                    .password.required
                                                : false
                                                " class="text-danger">Field is required</small>
                                            <small v-if="form_options.enableLoginDetails
                                                ? !$v.registration_form
                                                    .login_details
                                                    .password
                                                    .minLength
                                                : false
                                                " class="text-danger">Password must have at least 6
                                                letters.</small>
                                        </div>

                                        <div class="col-lg-4 col-sm-12" :class="{
                                            'has-error':
                                                form_options.enableLoginDetails
                                                    ? $v.registration_form
                                                        .login_details
                                                        .password_confirmation
                                                        .$invalid
                                                    : false,
                                        }">
                                            <label class="font-bold font-8">
                                                Confirm Password
                                                <span class="required">*</span></label>
                                            <input :disabled="!form_options.enableLoginDetails
                                                " v-model="registration_form
        .login_details
        .password_confirmation
        " type="password" />
                                            <small class="text-danger" v-if="form_options.enableLoginDetails ==
                                                true
                                                ? !$v.registration_form
                                                    .login_details
                                                    .password_confirmation
                                                    .sameAs
                                                : false
                                                ">Passwords must be
                                                identical.</small>
                                        </div>

                                        <div class="col-sm-12">
                                            <div v-show="form_options.clientHasAppUser
                                                ">
                                                <p style="margin-bottom: unset">
                                                    <input v-model="form_options.enableLoginDetails
                                                        " type="checkbox" />Update my login details ?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section section-sm">
                <div class="container">
                    <div>
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset class="fieldset-padding">
                                    <legend>Personal Details</legend>

                                    <div class="row">
                                        <div class="col-lg-1 col-sm-12">
                                            <label class="font-bold font-8">Title</label>
                                            <input v-model="registration_form
                                                .client_details.title
                                                " disabled="" type="text" />
                                        </div>
                                        <div class="col-lg-3 col-sm-12">
                                            <label class="font-bold font-8">First Name</label>
                                            <input v-model="registration_form
                                                .client_details
                                                .first_name
                                                " disabled="" type="text" />
                                        </div>
                                        <div class="col-lg-2 col-sm-12">
                                            <label class="font-bold font-8">Middle Name</label>
                                            <input disabled="" v-model="registration_form
                                                .client_details
                                                .middle_name
                                                " type="text" />
                                        </div>
                                        <div class="col-lg-3 col-sm-12">
                                            <label class="font-bold font-8">Family Name</label>
                                            <input v-model="registration_form
                                                .client_details
                                                .family_name
                                                " disabled="" type="text" />
                                        </div>
                                        <div class="col-lg-3 col-sm-12" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .client_details
                                                    .job_title.$invalid,
                                        }">
                                            <label class="font-bold font-8">
                                                Job Title
                                                <span class="required">*</span></label>
                                            <input v-model="registration_form
                                                .client_details
                                                .job_title
                                                " type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details
                                                .job_title.required
                                                ">Field is required</small>
                                        </div>
                                        <div class="col-lg-6 col-sm-12">
                                            <label class="font-bold font-8">Company</label>
                                            <input v-model="registration_form
                                                .client_details.company
                                                " disabled="" type="text" />
                                        </div>
                                        <div class="col-lg-6 col-sm-12" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .client_details.address
                                                    .$invalid,
                                        }">
                                            <label class="font-bold font-8">Address
                                                <span class="required">*</span></label>
                                            <input type="text" v-model="registration_form
                                                .client_details.address
                                                " />
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details.address
                                                .required
                                                ">Field is required</small>
                                        </div>
                                        <div class="col-lg-12 col-sm-12" v-if="form_options.isInvestor">
                                            <label class="font-bold font-8">Biography (Company/Personal
                                                Bio)
                                                <span class="required">*</span></label>
                                            <textarea v-model="registration_form
                                                .client_details
                                                .biography
                                                "></textarea>
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details
                                                .biography.required
                                                ">Field is required</small>
                                        </div>

                                        <div class="col-lg-3 col-sm-12" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .client_details
                                                    .country_id.$invalid,
                                        }">
                                            <label class="font-bold font-8">Country of residence
                                                <span class="required">*</span></label>
                                            <select v-model="registration_form
                                                .client_details
                                                .country_id
                                                ">
                                                <!-- <option :value="null">[Please Select]</option> -->
                                                <option v-for="country in lists.countries" :value="country.id"
                                                    :key="country.id">
                                                    {{ country.name }}
                                                </option>
                                            </select>
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details
                                                .country_id.required
                                                ">Field is required</small>
                                        </div>

                                        <div class="col-lg-3 col-sm-12">
                                            <label class="font-bold font-8">E-mail
                                                <span class="required">*</span></label>
                                            <input disabled="" v-model="registration_form
                                                .client_details.email
                                                " type="text" />
                                        </div>

                                        <div class="col-lg-3 col-sm-12" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .client_details
                                                    .additional_email
                                                    .$invalid,
                                        }">
                                            <label class="font-bold font-8">Other E-mail</label>
                                            <input v-model="registration_form
                                                .client_details
                                                .additional_email
                                                " type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details
                                                .additional_email.email
                                                ">Invalid email address</small>
                                        </div>
                                        <div class="col-lg-3 col-sm-12" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .client_details
                                                    .telephone.$invalid,
                                        }">
                                            <label class="font-bold font-8">Telephone
                                                <span class="required">*</span></label>
                                            <input v-model="registration_form
                                                .client_details
                                                .telephone
                                                " type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details
                                                .telephone.required
                                                ">Field is required</small>
                                        </div>
                                        <div class="col-lg-3 col-sm-12" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .client_details.mobile
                                                    .$invalid,
                                        }">
                                            <label class="font-bold font-8">Mobile
                                                <span class="required">*</span></label>
                                            <input v-model="registration_form
                                                .client_details.mobile
                                                " type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details.mobile
                                                .required
                                                ">Field is required</small>
                                        </div>
                                        <div class="col-lg-3 col-sm-12">
                                            <label class="font-bold font-7">Name of your Assistant</label>
                                            <input v-model="registration_form
                                                .client_details
                                                .assistant_name
                                                " type="text" />
                                        </div>
                                        <!-- <div class="clearfix" ></div> -->
                                        <div class="col-lg-3 col-sm-12">
                                            <label class="font-bold font-8">Assistant's Phone</label>
                                            <input v-model="registration_form
                                                .client_details
                                                .assistant_phone
                                                " type="text" />
                                        </div>
                                        <div class="col-lg-3 col-sm-12" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .client_details
                                                    .assistant_email
                                                    .$invalid,
                                        }">
                                            <label class="font-bold font-8">Assistant's E-mail</label>
                                            <input v-model="registration_form
                                                .client_details
                                                .assistant_email
                                                " type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form
                                                .client_details
                                                .assistant_email.email
                                                ">Invalid email address</small>
                                        </div>
                                    </div>
                                    <table>
                                        <tr>
                                            <td :class="{
                                                'has-error':
                                                    $v.registration_form
                                                        .client_details
                                                        .nationality_id
                                                        .$invalid,
                                            }">
                                                <label class="font-bold">Nationality
                                                    <span class="required">*</span></label>
                                                <select v-model="registration_form
                                                    .client_details
                                                    .nationality_id
                                                    ">
                                                    <option :value="null">
                                                        [Please Select]
                                                    </option>
                                                    <option v-for="(
                                                            country, index
                                                        ) in lists.countries" :value="country.id" :key="index">
                                                        {{ country.name }}
                                                    </option>
                                                </select>
                                                <small class="text-danger" v-if="!$v.registration_form
                                                    .client_details
                                                    .nationality_id
                                                    .required
                                                    ">Field is required</small>
                                            </td>
                                        </tr>
                                        <!-- <tr>
                                            <td :class="{'has-error' : $v.registration_form.client_details.email_confirmation.$invalid }">
                                                <label>Confirm E-mail *</label>
                                                <input v-model="registration_form.client_details.email_confirmation" type="text" />
                                                <small class="text-danger" v-if="!$v.registration_form.client_details.email_confirmation.sameAs">Emails didnt match</small>
                                            </td>
                                        </tr> -->
                                        <!-- <tr>
                                            <td>
                                                <label>Fax</label>
                                                <input v-model="registration_form.client_details.fax" type="text" />
                                            </td>
                                        </tr> -->
                                    </table>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section section-sm" v-if="form_options.isInvestor &&
                form_options.allow_investor_slots_registration
                ">
                <div class="container">
                    <div class="">
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset class="fieldset-padding">
                                    <legend>Days of Attendance</legend>
                                    <table style="
                                            display: flex;
                                            flex-direction: column;
                                            overflow: scroll;
                                        " class="custom-scroller" :class="{
                                            'has-error':
                                                $v.registration_form
                                                    .available_slot.$invalid,
                                        }">
                                        <tr>
                                            <td style="min-width: 1000px">
                                                <p class="font-9" v-html="conferenceTextData.investor_slots_instruction_text
                                                    "></p>
                                            </td>
                                        </tr>
                                        <tr class="dates_investor">
                                            <td v-if="form_options.allow_investor_slots_registration
                                                ">
                                                <div v-if="!hideTimeZone">
                                                    <label class="font-87" style="min-width: 1000px">
                                                        <b>
                                                            Please select your time
                                                            zone/city then select
                                                            your time preferred time
                                                            slots
                                                        </b>
                                                        <span class="required">*</span>
                                                    </label>
                                                    <VueSelect style="
                                                            display: block;
                                                            margin-bottom: 1rem;
                                                            width: 50%;
                                                        " placeholder="Select Time Zone" :options="this.timeZones"
                                                        @input="changeTimeZone" :value="this.default_timezone"
                                                        :disabled="true"></VueSelect>
                                                </div>

                                                <div v-if="this.registration_form
                                                    .timezone.code ||
                                                    this.default_timezone
                                                    ">
                                                    <div v-for="(
                                                            timeslots, date
                                                        ) in lists.agenda_slots" :key="date">
                                                        <label>
                                                            {{
                                                                initDateFormat(
                                                                    date
                                                                )
                                                            }}
                                                        </label>
                                                        <label>
                                                            <input @change="selectAllSlots
                                                                " type="checkbox" :value="date" />
                                                            All
                                                        </label>
                                                        <label v-for="timeslot in timeslots" :key="timeslot.id">
                                                            <input v-model="registration_form.available_slot
                                                                " type="checkbox" :value="timeslot.id
        " />
                                                            {{
                                                                timeslot.start_time
                                                            }}
                                                        </label>
                                                        <hr style="
                                                                margin-top: 8px;
                                                                margin-bottom: 8px;
                                                            " />
                                                    </div>
                                                </div>

                                                <div v-else class="dump-height">
                                                    <p>
                                                        Your time slots will
                                                        appear here
                                                    </p>
                                                </div>
                                            </td>
                                            <td v-if="!form_options.allow_investor_slots_registration
                                                ">
                                                <p>
                                                    Registration Will be
                                                    available soon
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p class="font-bold font-9" style="margin-bottom: 0px">
                                                    If you require further
                                                    assistance, please email us
                                                    at
                                                    <a :href="'mailto:' +
                                                        conferenceTextData.conference_email
                                                        ">{{
        conferenceTextData.conference_email
    }}</a>
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="form_options.isPresenter" class="section section-sm">
                <div class="container">
                    <div class="">
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset class="fieldset-padding">
                                    <legend>Colleagues Registration</legend>
                                    <p>
                                        If you wish to register your
                                        colleagues,<b>
                                            please click on the check box next
                                            to each name.</b>
                                        You can also edit your colleagues’
                                        information by clicking on the edit
                                        button. Once you complete the
                                        registration, your colleagues will
                                        receive the registration confirmation
                                        email with their unique username and
                                        password.
                                    </p>
                                    <p>
                                        Due to high investor demand & limited
                                        meeting room space, attendance from each
                                        company is limited to 2-3 attendees from
                                        top management and/or Investor
                                        Relations.
                                    </p>
                                    <PresenterMatesTable :mates="lists.presnter_mates" :mapSelectedMatesData="mapSelectedMatesData
                                        " :updateMateData="updateMateData"></PresenterMatesTable>
                                    <p style="margin-bottom: 0px">
                                        If you wish to invite additional company
                                        members or remove any, please click

                                        <a style="
                                                color: #0000ee;
                                                text-decoration: underline;
                                            " :href="'mailto:' +
                                                conferenceTextData.conference_email +
                                                '?subject=Additional%20Invite&amp;body=Full%20Name:%0DCompany%20Name:%0DJob%20title:%0DTelephone:%0DMobile:%0DEmail:%0DAssistant%20email%20(if%20available):%0D'
                                                ">here</a>
                                    </p>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section section-sm" v-if="form_options.isPresenter">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12" :class="{
                            'has-error':
                                $v.registration_form.media_interview
                                    .$invalid,
                        }">
                            <fieldset class="fieldset-padding">
                                <legend>
                                    Media Interview
                                    <span class="text-danger">*</span>
                                </legend>
                                <p class="text-danger" v-if="registration_form.media_interview ==
                                    null
                                    ">
                                    This question is mandatory
                                </p>
                                <span>Would you like to have a media
                                    interview?</span>
                                <select name="media" id="media" class="screenMeeting"
                                    v-model="registration_form.media_interview" required>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section section-sm" v-if="form_options.isPresenter">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12" :class="{
                            'has-error':
                                $v.registration_form.screen.$invalid,
                        }">
                            <fieldset class="fieldset-padding">
                                <legend>
                                    Audio Visual (A/V)
                                    <span class="text-danger">*</span>
                                </legend>
                                <p class="text-danger" v-if="registration_form.screen == null">
                                    This question is mandatory
                                </p>
                                <span>Would you like to have screen in your
                                    meeting room for presentation
                                    purposes?</span>
                                <select name="screen" id="screen" class="screenMeeting" v-model="registration_form.screen"
                                    required>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section section-sm" v-if="conference.hotel_accommodation">
                <div class="container">
                    <div class="">
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset class="fieldset-padding">
                                    <legend>
                                        Hotel &amp; Accommodation Details
                                    </legend>
                                    <div v-html="conference.hotel_accommodation"></div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section section-sm" v-if="form_options.enableRemarks == 1">
                <div class="container">
                    <div class="">
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset class="fieldset-padding">
                                    <legend>Remarks</legend>
                                    <textarea style="margin-bottom: unset" v-model="registration_form.remarks"
                                        placeholder="Enter your remarks here"></textarea>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="form_options.isPresenter" class="section section-sm">
                <presenter-availability-page ref="presenterAvailabilityRef" />
            </section>

            <section class="section section-sm">
                <div class="container">
                    <div class="">
                        <div class="row">
                            <div class="col-md-12">
                                <input @click="registerClientSubmitted($event)" :value="form_options.isPresenter
                                    ? 'Submit'
                                    : nextOrSubmitButtonTextIfInvestor()
                                    " type="submit" class="btn btn-outline-clr btn-sm custom-submit" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
// import Datepicker from 'vuejs-datepicker';
import RegisterMates from "@/components/RegisterPresenterMates.vue";
import PresenterMatesTable from "../../views/auth/registration/presenterRegistration/PresenterMatesTable.vue";
import PresenterAvailabilityPage from "../../views/auth/registration/presenterRegistration/PresenterAvailabilityPage.vue";

import _ from "lodash";
import Api from "@/Api";
import VueSelect from "vue-select";
import { mapState, mapGetters } from "vuex";
import microsoftConfig from "@/config/microsoft";
import { minLength, required, sameAs, email } from "vuelidate/lib/validators";

var Timer = require("easytimer");
var momentTZ = require("moment-timezone");
var moment = require("moment");

export default {
    name: "Register",
    components: {
        VueSelect,
        RegisterMates,
        PresenterMatesTable,
        PresenterAvailabilityPage,
    },
    data() {
        return {
            firstTimeRegister: 0,
            hideTimeZone: true,
            default_timezone: {
                label:
                    "Europe/London" +
                    " (GMT" +
                    momentTZ.tz("Europe/London").format("Z") +
                    ")",
                code: "Europe/London",
            },
            selected_group: 0,
            selected_tab: 0,
            is_valid_selected_colleagues: true,
            selected_colleagues_error_message: null,
            selected_colleagues: [],
            enable_mates_registration: false,
            registration_form: {
                login_details: {
                    username: "",
                    password: "",
                    password_confirmation: "",
                },
                client_details: {
                    first_name: "",
                    middle_name: "",
                    family_name: "",
                    title: "",
                    job_title: "",
                    company: "",
                    address: "",
                    country_id: "",
                    nationality_id: "",
                    email: "",
                    // email_confirmation: '',
                    additional_email: "",
                    telephone: "",
                    // fax: '',
                    mobile: "",
                    assistant_name: "",
                    assistant_phone: "",
                    assistant_email: "",
                },
                timezone: {
                    label:
                        "Asia/Kuwait" +
                        " (GMT" +
                        momentTZ.tz("Asia/Kuwait").format("Z") +
                        ")",
                    code: "Asia/Kuwait",
                },
                arrival_dates: {
                    arrival_date: "",
                    arrival_time: "",
                    departure_date: "",
                    departure_time: "",
                },
                available_slot: [],
                presenter_slots: [],
                conference_dates: {},
                selected_group: 0,
                remarks: "",
                screen: false,
                media_interview: false,
                prefer_interview: 0,
            },
            form_options: {
                enableRemarks: 1,
                disable_arrival_dates: false,
                disable_depature_dates: false,
                disable_login_details_area: true,
                isInvestor: false,
                isPresenter: false,
                allow_investor_slots_registration: false,
                enableLoginDetails: false,
                clientHasAppUser: true,
                datepicketSetup: {
                    disabledDates: {
                        to: null,
                        from: null,
                    },
                },
            },
            lists: {
                countries: [],
                agenda_slots: [],
                closed_days: [],
                closed_conference_days: [],
                presnter_mates: [],
            },
            conference: {},
            remaining_timer: "00:00",
            errors: {},
            registration_text: "",
            conference_email: "",
            investor_slots_instruction_text: "",
        };
    },
    validations() {
        let rules = {
            registration_form: {
                login_details: this.loginDetailsRules,
                client_details: this.clientDetailsRules,
                arrival_dates: this.arrivalDepatureRules,
            },
        };
        let allowRegistration = this.form_options.isInvestor
            ? JSON.parse(localStorage.getItem("conference"))
                .allow_investor_slots_registration
            : true;
        if (allowRegistration && this.form_options.isInvestor) {
            rules.registration_form["available_slot"] = { required };
        } else {
            rules.registration_form["available_slot"] = {};
        }
        if (this.form_options.isPresenter) {
            rules.registration_form["screen"] = { required };
            rules.registration_form["media_interview"] = { required };
        }

        // if( this.form_options.isPresenter ) rules.registration_form['presenter_slots'] = {required};
        return rules;
    },
    watch: {
        "form_options.disable_arrival_dates": function (newVal, oldVal) {
            if (newVal == true) {
                this.registration_form.arrival_dates.arrival_date = null;
                this.registration_form.arrival_dates.arrival_time = null;
            }
        },
        "form_options.disable_depature_dates": function (newVal, oldVal) {
            if (newVal == true) {
                this.registration_form.arrival_dates.departure_date = null;
                this.registration_form.arrival_dates.departure_time = null;
            }
        },
    },
    methods: {
        mapSelectedMatesData(matesIds, matesData) {
            const selectedOnes = matesData.filter((mate) =>
                matesIds.includes(mate.mateId)
            );
            this.selected_colleagues = selectedOnes;

            // this data is set on availability page onCreate method, delete all user selects until he submits
            localStorage.removeItem("selected-colleagues-data");

            this.is_valid_selected_colleagues =
                matesIds.length === selectedOnes.length;
            if (this.is_valid_selected_colleagues === true) {
                let [valid, message] =
                    this.validateSelectedPresentersMatesData(selectedOnes);
                this.is_valid_selected_colleagues = valid;
                this.selected_colleagues_error_message = message;
            }
        },
        updateMateData(updatedMate) {
            this.lists.presnter_mates = this.lists.presnter_mates.map(
                (mate) => {
                    if (mate.id === updatedMate.id) return updatedMate;
                    return mate;
                }
            );
            localStorage.setItem(
                "registeration.presenter_mates",
                JSON.stringify(this.lists.presnter_mates)
            );
        },
        validateSelectedPresentersMatesData(mates) {
            let isValid = mates
                .map((mate) => mate.valid)
                .every((item) => item === true);
            if (isValid) {
                return [true, null];
            }
            let message = "<div>";
            mates.map((mate) => {
                let keys = Object.keys(mate.errors);

                if (mate.valid === false) {
                    message += ` <ul> <li style="font-size: 14px;font-weight: bold;color: red;" > Colleague: (${mate.mateFormData.first_name} ${mate.mateFormData.family_name}) Data is incompelete: Please click on "Edit" & add the below info </li>`;

                    if (keys.length > 0) {
                        for (let i = 0; i < keys.length; i++) {
                            message += `<li style="font-size:12px;margin-left:10px;color:red">${mate.errors[keys[i]]
                                } </li>`;
                        }
                    }
                }
                return mate;
            });
            message += "</div>";
            return [false, message];
        },
        validate() {
            this.$v.$touch();
            this.$nextTick(() => {
                this.scrollToFirstError();
            });
        },
        nextOrSubmitButtonTextIfInvestor() {
            let investor_redirection_url = localStorage.getItem(
                "investor_redirection_url"
            );

            investor_redirection_url = investor_redirection_url
                ? investor_redirection_url
                : "/user/preferences";

            let client_type = localStorage.getItem("client")
                ? JSON.parse(localStorage.getItem("client")).client.client_type
                    .type
                : null;

            if (
                this.form_options.allow_investor_slots_registration &&
                investor_redirection_url === "/user/preferences" &&
                client_type == 1
            ) {
                return "Next";
            }

            return "Submit";
        },
        registerClientSubmitted(e) {
            e.preventDefault();

            this.errors = {};
            if (this.$v.registration_form.$invalid == true) {
                this.validate();
                return;
            }

            let data = this.setupRegistrationDataRequest();
            data = _.omit(data, [
                "first_name",
                "middle_name",
                "family_name",
                "company",
                "company_id",
                // "country_id",
                "email",
                // "nationality_id",
                "title",
            ]);

            if (this.form_options.isPresenter) {
                if (!this.is_valid_selected_colleagues) {
                    this.showAlert(this.selected_colleagues_error_message);
                } else {
                    let presenterData = {
                        logged_presenter: data,
                        selected_colleagues: this.selected_colleagues,
                    };

                    this.$store.dispatch("savePresenterFormData", presenterData);

                    this.$refs.presenterAvailabilityRef.submitAndRegister(
                        presenterData.logged_presenter,
                        presenterData.selected_colleagues
                    );
                }
                return;
            }

            Api()
                .post("auth/signup", data)
                .then((response) => {
                    let data = response.data;
                    let conference_end_date = new Date(
                        this.conference.end_date
                    ).getTime();
                    let current_date = Date.now();
                    let client_type = localStorage.getItem("client")
                        ? JSON.parse(localStorage.getItem("client")).client
                            .client_type.type
                        : null;
                    if (!client_type) {
                        client_type = localStorage.getItem(
                            "registeration.client"
                        )
                            ? JSON.parse(
                                localStorage.getItem("registeration.client")
                            ).client.client_type.type
                            : null;
                    }

                    // if (client_type == 1) {
                    if (this.firstTimeRegister) {
                        Api()
                            .get(`me`, {
                                params: {
                                    username:
                                        this.registration_form.login_details
                                            .username,
                                },
                            })
                            .then((res) => {
                                let user = res.data.user;

                                let investor_redirection_url;
                                if (client_type == 1) {
                                    investor_redirection_url = JSON.parse(
                                        localStorage.getItem("conference")
                                    ).investor_redirection_route;
                                } else {
                                    investor_redirection_url =
                                        "/auth/registration/thank";
                                }

                                this.$store
                                    .dispatch("login", { user: user })
                                    .then(() => {
                                        window.location.href =
                                            investor_redirection_url
                                                ? investor_redirection_url
                                                : "/user/preferences"; // this.$router.push({ name: 'preferences' });
                                    });
                            })
                            .catch((err) => {
                                if (err.response.data.logout) {
                                    alert(
                                        "Your session expired .... Please identify your self"
                                    );
                                    this.$store
                                        .dispatch("endRegisrationProccess")
                                        .then(() =>
                                            this.$router.push({
                                                name: "Identify",
                                            })
                                        );
                                }
                            });
                        return;
                    }

                    let investor_redirection_url;
                    if (client_type == 1) {
                        investor_redirection_url = JSON.parse(
                            localStorage.getItem("conference")
                        ).investor_redirection_route;
                    } else {
                        investor_redirection_url = "/auth/registration/thank";
                    }

                    investor_redirection_url = investor_redirection_url
                        ? investor_redirection_url
                        : "/user/preferences";
                    this.$router.push(investor_redirection_url);
                    // }
                })
                .catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;

                            if (err.logout) {
                                alert(
                                    "Your session expired .... Please identify your self"
                                );
                                this.$store
                                    .dispatch("endRegisrationProccess")
                                    .then(() =>
                                        this.$router.push({ name: "Identify" })
                                    );
                            }

                            this.errors = this.errorMapper(err.errors);
                            setTimeout(() => this.validate(), 1000);
                        }
                    }
                });
        },
        errorMapper(errors) {
            var errors_array = [];
            errors.forEach(($element) => {
                errors_array[$element.name] = $element.message;
            });
            return errors_array;
        },
        showAlert(text) {
            this.$swal({
                toast: true,
                html: text,
                position: "center",
            });
        },
        scrollToFirstError() {
            let domRect = document
                .querySelector(".error-summary,.has-error")
                .getBoundingClientRect();
            window.scrollTo(
                domRect.left + document.documentElement.scrollLeft,
                domRect.top + document.documentElement.scrollTop - 255
            );
        },
        setupRegistrationDataRequest() {
            let login_details = this.registration_form.login_details;
            let client_details = this.registration_form.client_details;
            let arrival_dates = this.registration_form.arrival_dates;
            if (this.form_options.enableLoginDetails == false) {
                delete login_details["username"];
                delete login_details["password"];
                delete login_details["password_confirmation"];
            }
            return {
                ...login_details,
                ...client_details,
                ...arrival_dates,
                timezone: this.registration_form.timezone.code,
                available_slot: this.form_options.isPresenter
                    ? this.registration_form.presenter_slots
                    : this.form_options.allow_investor_slots_registration
                        ? this.registration_form.available_slot
                        : [],
                remarks: this.registration_form.remarks,
                need_screen: this.registration_form.screen,
                media_interview: this.registration_form.media_interview,
                prefer_interview: this.registration_form.prefer_interview,
                invitation_code: this.registration_form.invitation_code,
            };
        },
        initClientDataIntoForm() {
            const client_all_data = JSON.parse(
                localStorage.getItem("registeration.client")
            );
            let client = client_all_data.client;
            // let user = client.user;

            this.registration_form.client_details = {
                first_name: client.first_name,
                middle_name: client.middle_name,
                family_name: client.family_name,
                title: client.title.name,
                job_title: client.job_title,
                company: client.company.name,
                address: client.address,
                country_id: client.country_id,
                nationality_id: client.nationality_id,
                email: client.email,
                // email_confirmation: client.email_confirmation,
                additional_email: client.additional_email,
                telephone: client.telephone,
                // fax: client.fax,
                mobile: client.mobile,
                assistant_name: client.assistant_name,
                assistant_phone: client.assistant_phone,
                assistant_email: client.assistant_email,
                company_id: client.company_id,
                client_type_id: client.client_type_id,
                biography: client.biography,
            };

            this.registration_form.timezone = client_all_data.timezone
                ? {
                    label:
                        client_all_data.timezone +
                        " (GMT" +
                        momentTZ.tz(client_all_data.timezone).format("Z") +
                        ")",
                    code: client_all_data.timezone,
                }
                : {
                    label: "Please select your timezone",
                    code: "",
                };
            this.registration_form.arrival_dates = {
                arrival_date: client_all_data.arrival_date,
                arrival_time: client_all_data.arrival_time,
                departure_date: client_all_data.departure_date,
                departure_time: client_all_data.departure_time,
            };
            this.registration_form.login_details.username = client.user
                ? client.user.username
                : "";
            this.registration_form.remarks = client_all_data.remarks;
            this.registration_form.screen = client_all_data.presenter_property
                ? client_all_data.presenter_property.need_screen
                : null;
            this.registration_form.media_interview =
                client_all_data.presenter_property
                    ? client_all_data.presenter_property.media_interview
                    : null;
            this.registration_form.available_slot = Array.isArray(
                client_all_data.available_slot
            )
                ? client_all_data.available_slot
                : [];
            this.registration_form.invitation_code =
                client_all_data.invitation_code;
            this.registration_form.prefer_interview =
                client_all_data.prefer_interview;

            this.form_options.isInvestor = client.client_type.type == 1;
            this.form_options.isPresenter = client.client_type.type == 2;
            this.form_options.allow_investor_slots_registration = JSON.parse(
                localStorage.getItem("conference")
            ).allow_investor_slots_registration
                ? true
                : false;
            this.form_options.clientHasAppUser = !!client.user;
            if (!this.form_options.clientHasAppUser) {
                this.form_options.enableLoginDetails = true;
            }
            this.form_options.disable_arrival_dates =
                client_all_data.arrival_date == "" ||
                client_all_data.arrival_date == null;
            this.form_options.disable_depature_dates =
                client_all_data.departure_date == "" ||
                client_all_data.departure_date == null;
        },
        initForm() {
            let lists = JSON.parse(localStorage.getItem("registeration.lists"));
            this.lists.countries = _.orderBy(lists.countries_list, [
                (c) => c.name.toLowerCase(),
            ]);
            this.lists.agenda_slots = lists.agenda_slots;
            this.lists.closed_days = lists.closed_days;
            this.lists.closed_conference_days = lists.closed_conference_days;
            this.form_options.datepicketSetup.disabledDates.to = new Date(
                new Date(this.conference.start_date) - 7 * 24 * 60 * 60 * 1000
            );
            this.form_options.datepicketSetup.disabledDates.from = new Date(
                new Date(this.conference.end_date).getTime() +
                7 * 24 * 60 * 60 * 1000 +
                86400000
            );
            this.form_options.enableRemarks =
                this.conference.web_enable_remark_box;
        },
        selectAllSlots(e) {
            let el = e.target;
            let date = el.value;
            let timeslots = this.lists.agenda_slots[date];
            for (let i in timeslots) {
                let slot = timeslots[i];
                if (el.checked == true) {
                    // registration_form.available_slot
                    if (
                        !this.registration_form.available_slot.includes(
                            slot.id.toString()
                        )
                    ) {
                        this.registration_form.available_slot.push(
                            slot.id.toString()
                        );
                    }
                } else {
                    let indexToDelete =
                        this.registration_form.available_slot.indexOf(
                            slot.id.toString()
                        );
                    this.registration_form.available_slot.splice(
                        indexToDelete,
                        1
                    );
                }
            }
        },
        initTimer() {
            var scope = this;
            let timerInSeconds = localStorage.getItem("registeration.timer")
                ? localStorage.getItem("registeration.timer")
                : 1;
            timerInSeconds = parseInt(timerInSeconds);
            if (timerInSeconds == 0) {
                this.$store
                    .dispatch("endRegisrationProccess")
                    .then(() => scope.$router.push({ name: "identify" }));
            }
            var timer = new Timer();
            timer.start({
                countdown: true,
                startValues: { seconds: timerInSeconds },
            });

            scope.remaining_timer = timer.getTimeValues().toString();

            timer.addEventListener("secondsUpdated", function (e) {
                scope.remaining_timer = timer.getTimeValues().toString();
                localStorage.setItem(
                    "registeration.timer",
                    timer.getTotalTimeValues().seconds
                );
            });
            timer.addEventListener("targetAchieved", function (e) {
                alert("Your session expired .... Please identify your self");
                scope.$store.dispatch("endRegisrationProccess").then(() => {
                    setTimeout(() => {
                        let client_storage = localStorage.getItem("client");
                        if (!_.isEmpty(client_storage)) {
                            scope.$router.push({ name: "identify" });
                        } else {
                            scope.$router.push({ name: "login" });
                        }
                    });
                }, 2000);
            });
        },
        fetchDataForUpdate() {
            Api()
                .get(`auth/get-required-data-update-profile`)
                .then((response) => {
                    let data = response.data;
                    this.$store
                        .dispatch("startRegistrationProccess", data)
                        .then(() => {
                            this.startInit();
                        });
                })
                .catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            alert(err.errors[0].message);
                            this.$store.dispatch("endRegisrationProccess");
                            window.location.replace("/auth/login");
                        }
                    }
                });
        },
        startInit() {
            let conference = JSON.parse(localStorage.getItem("conference"));
            this.conference = conference;
            this.initForm();
            this.initTimer();
            this.initClientDataIntoForm();
            this.initPresenterMates();
        },
        initDateFormat(date) {
            return moment(date).format("DD-MM-YYYY");
        },
        initPresenterMates() {
            let mates = JSON.parse(
                localStorage.getItem("registeration.presenter_mates")
            );
            if (mates && mates.length > 0 && mates !== "undefined") {
                // in case of wrong parsing
                this.lists.presnter_mates = mates;
            }
        },
        timeUpdateHandler(event, input_name) {
            let timepicker = event.data;
            var time = `${timepicker.HH}:${timepicker.mm}`;
            if (input_name == "arrival_time") {
                this.registration_form.arrival_dates.arrival_time = time;
            } else if (input_name == "departure_time") {
                this.registration_form.arrival_dates.departure_time = time;
            }
        },
        getTimer(input_name) {
            var hour,
                min = null;
            if (input_name == "arrival_time") {
                let time = this.registration_form.arrival_dates.arrival_time;
                if (time != null && time != "") {
                    let time_arr = time.split(":");
                    hour = time_arr[0];
                    min = time_arr[1];
                }
            } else if (input_name == "departure_time") {
                let time = this.registration_form.arrival_dates.departure_time;
                if (time != null && time != "") {
                    let time_arr = time.split(":");
                    hour = time_arr[0];
                    min = time_arr[1];
                }
            }
            return {
                HH: hour,
                mm: min,
            };
        },
        validateArrivalDate(value) {
            for (let slot in this.registration_form.available_slot) {
                if (
                    moment(value).isAfter(
                        this.registration_form.available_slot[slot],
                        "date"
                    )
                ) {
                    return false;
                }
            }
            return true;
        },
        validateDepatureRule(value) {
            for (let slot in this.registration_form.available_slot) {
                if (
                    moment(value).isBefore(
                        this.registration_form.available_slot[slot],
                        "date"
                    )
                ) {
                    return false;
                }
            }
            return true;
        },
        changeTimeZone({ code, label }) {
            // override timezone to default
            this.registration_form.timezone = this.default_timezone;

            Object.keys(this.lists.agenda_slots).forEach((date) => {
                this.lists.agenda_slots[date] = this.lists.agenda_slots[
                    date
                ].map((slot) => {
                    const startTime = slot.start_time.replace(/\(.+\)/, "");
                    slot.start_time = this.convertTimeZone(
                        `${slot.date} ${startTime}`,
                        this.registration_form.timezone.code ||
                        this.default_timezone.code,
                        code
                    );
                    return slot;
                });
            });
            this.registration_form.timezone.code = code;
            this.registration_form.timezone.label = label;
        },

        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format("L");
            time.tz("Asia/Saudi Arabia");
            const londonTime = time.format("L");
            time.tz(newTimeZone);
            const newTime = time.format("L");
            const diff = moment(newTime).diff(moment(londonTime), "days");
            let res = time.format("HH:mm");
            if (diff) {
                res += "(" + (diff > 0 ? "+" : "") + diff + ")";
            }
            return res;
        },
        integrateWithOutlookCalendar() {
            const decodePermissionScope = encodeURIComponent(
                microsoftConfig.scope
            );
            const encodedRedirectURI = encodeURIComponent(
                microsoftConfig.redirect_uri
            );
            const authorizeURI = `${microsoftConfig.authorize_uri}?client_id=${microsoftConfig.client_id}&response_type=code&redirect_uri=${encodedRedirectURI}&response_mode=query&scope=${decodePermissionScope}&state=12345`;

            const newWindow = this.openPopup(
                authorizeURI,
                "Microsoft Security",
                500,
                700
            );

            let detectPopupCloseInterval = setInterval(() => {
                if (newWindow.closed) {
                    clearInterval(detectPopupCloseInterval);
                    this.postAuthorizationCode(window.access_code);
                }
            }, 1000);
        },
        openPopup(url, title, w, h) {
            const dualScreenLeft =
                window.screenLeft !== undefined
                    ? window.screenLeft
                    : window.screenX;
            const dualScreenTop =
                window.screenTop !== undefined
                    ? window.screenTop
                    : window.screenY;

            const width = window.innerWidth
                ? window.innerWidth
                : document.documentElement.clientWidth
                    ? document.documentElement.clientWidth
                    : screen.width;
            const height = window.innerHeight
                ? window.innerHeight
                : document.documentElement.clientHeight
                    ? document.documentElement.clientHeight
                    : screen.height;

            const systemZoom = width / window.screen.availWidth;
            const left = (width - w) / 2 / systemZoom + dualScreenLeft;
            const top = (height - h) / 2 / systemZoom + dualScreenTop;
            const newWindow = window.open(
                url,
                title,
                `
      scrollbars=yes,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `
            );

            if (window.focus) newWindow.focus();
            return newWindow;
        },
        postAuthorizationCode(code) {
            if (!code) {
                return this.$toastr.e(
                    "Failed authorize outlook calendar! Please try again"
                );
            }

            const { client_id, scope, redirect_uri, client_secret } =
                microsoftConfig;
            const data = {
                client_id,
                scope,
                code,
                redirect_uri,
                grant_type: "authorization_code",
                client_secret,
            };

            Api()
                .post("/auth/microsoft-authorization-code", data)
                .then((res) => {
                    this.$toastr.s(
                        "Your meetings will be synced with outlook calendar"
                    );
                })
                .catch((e) =>
                    this.$toastr.e(
                        "Failed authorize outlook calendar! Please try again"
                    )
                );
        },
    },
    created() {
        this.firstTimeRegister = localStorage.getItem("firstTimeRegister")
            ? parseInt(localStorage.getItem("firstTimeRegister"))
            : 0;

        if (
            !localStorage.getItem("registeration.client") &&
            !localStorage.getItem("client")
        ) {
            alert("Your session expired .... Please identify your self");
            this.$store
                .dispatch("endRegisrationProccess")
                .then(() => this.$router.push({ name: "Identify" }));
        } else {
            if (this.firstTimeRegister) this.startInit();
            else this.fetchDataForUpdate();
        }

        const lateRegisterAvailableSLots = localStorage.getItem(
            "lateRegisterAvailableSLots"
        );
        let late;
        if (
            lateRegisterAvailableSLots &&
            lateRegisterAvailableSLots != "undefined"
        ) {
            late = JSON.parse(lateRegisterAvailableSLots);
        }

        Object.keys(this.lists.agenda_slots).map((item, index) => {
            if (late && late[item]) {
                this.registration_form.available_slot.push(item);
            }
        });

        this.registration_form.conference_dates = JSON.parse(
            localStorage.getItem("registeration.conference_dates")
        );

        if (
            this.registration_form.available_slot &&
            this.registration_form.available_slot.length
        ) {
            if (this.form_options.isPresenter) {
                let keys = Object.keys(this.lists.agenda_slots);
                if (keys.length) {
                    const dayNumber =
                        this.registration_form.conference_dates[
                        this.registration_form.available_slot[0]
                        ];
                    this.selected_group = Math.ceil(
                        dayNumber / this.conference.split_days
                    );
                }
            }
        }

        if (this.registration_form.timezone.code) {
            // override timezone to default
            this.registration_form.timezone = this.default_timezone;

            console.log(this.registration_form.timezone.code);
            Object.keys(this.lists.agenda_slots).forEach((date) => {
                this.lists.agenda_slots[date] = this.lists.agenda_slots[
                    date
                ].map((slot) => {
                    slot.start_time = this.convertTimeZone(
                        `${slot.date} ${slot.start_time}`,
                        this.default_timezone.code,
                        this.registration_form.timezone.code
                    );
                    return slot;
                });
            });
        }
    },
    computed: {
        ...mapState(["timeZones"]),
        ...mapGetters(["conferenceTextData"]),
        loginDetailsRules() {
            if (this.form_options.enableLoginDetails == true) {
                return {
                    username: { required, minLength: minLength(6) },
                    password: { required, minLength: minLength(6) },
                    password_confirmation: { sameAs: sameAs("password") },
                };
            }
            return {};
        },
        clientDetailsRules() {
            const rules = {
                job_title: { required },
                address: { required },
                country_id: { required },
                /* email: {required, email},
                email_confirmation: {sameAs: sameAs('email')},*/
                additional_email: { email },
                telephone: { required },
                mobile: { required },
                assistant_name: "",
                assistant_phone: {},
                assistant_email: { email },
                nationality_id: { required },
            };
            if (this.form_options.isInvestor) {
                rules["biography"] = { required };
            }

            return rules;
        },
        arrivalDepatureRules() {
            var depature_rules = {};
            var arrival_rules = {};
            if (
                !this.form_options.disable_arrival_dates &&
                this.form_options.isPresenter == true
            ) {
                arrival_rules = {
                    arrival_date: {
                        required,
                        minValue: this.validateArrivalDate,
                    },
                    arrival_time: { required },
                };
            } else {
                arrival_rules = {
                    arrival_date: {},
                    arrival_time: {},
                };
            }

            if (
                !this.form_options.disable_depature_dates &&
                this.form_options.isPresenter == true
            ) {
                depature_rules = {
                    departure_date: {
                        required,
                        minValue: this.validateDepatureRule,
                    },
                    departure_time: { required },
                };
            } else {
                depature_rules = {
                    departure_date: {},
                    departure_time: {},
                };
            }

            return {
                ...arrival_rules,
                ...depature_rules,
            };
        },
    },
};
</script>

<style lang="scss">
.registration-page {
    @import "../../../public/assets/css/style";

    legend {
        font-size: 22px;
        font-weight: bold;
    }

    .text_underline {
        text-decoration: underline;
        color: #3498db;
    }
}
</style>

<style scoped>
.dump-height {
    min-height: 300px;
}

.dump-height>p {
    padding: 10px 0;
}

@media screen and (max-width: 62em) {
    .mobile-view-header {
        margin-top: 130px;
    }
}

.dates_investor input[type="checkbox"] {
    margin: 0 0px 0 14px !important;
}

.alert-danger {
    margin-top: 10px;
}

.list-group {
    margin: 5px;
}

.list-group li {
    margin: 5px;
    list-style-type: disc;
}

.font-bold {
    font-weight: bold;
}

.fieldset-padding {
    padding: 0xp;
}

.custom-scroller::-webkit-scrollbar {
    width: 1px;
    height: 1px;
}

.custom-scroller::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3);
}

.custom-submit {
    margin-right: 10px;
}

input[type="color"]:not(textarea),
input[type="email"]:not(textarea),
input[type="number"]:not(textarea),
input[type="password"]:not(textarea),
input[type="tel"]:not(textarea),
input[type="text"]:not(textarea),
input[type="url"]:not(textarea),
textarea:not(textarea) {
    height: 34px;
    padding: 0 10px;
    line-height: 30px;
}

.hidden {
    display: none;
}

.nav-a-pd {
    padding: 5px 6px;
}

.nav-a-pd:hover {
    border-left: 1px solid #ebe7e7;
    border-right: 1px solid #ebe7e7;
}

.with-border {
    border: 1px solid #ebe7e7;
    border-radius: 2px;
    border-bottom: unset;
}

.with-bottom-border {
    border-bottom: 1px solid #ebe7e7;
}

.display-on-sm {
    display: none;
}

.screenMeeting {
    width: 100px;
    margin: 0 2em;
    text-align: center;
}

@media (max-width: 600px) {
    .custom-submit {
        margin: 1rem auto !important;
    }

    .mx-auto-md {
        margin: auto;
    }

    .display-on-sm {
        display: unset;
    }
}
</style>